<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_organization')"
        >
          {{ $t('organizations.createOrg') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          :placeholder="$t('organizations.search')"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('organizations.customerName') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('organizations.bank') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('organizations.rib') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('organizations.cryptocurrency') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('organizations.email') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('organizations.maxPayoutAmount') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('organizations.payoutValidationDelay') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('organizations.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(organization) in paginatedOrganizations" :key="organization.id">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="form-check mb-0">
                    <input class="form-check-input shadow-none" type="checkbox" />
                  </div>
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    <img src="../../../assets/images/user/user3.jpg" class="rounded-circle me-8" width="24" height="24" alt="user" />
                    {{ organization.name }}
                  </div>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.bankDomiciliation }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.rib }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.cryptoAccount }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.email }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.maxPayoutAmount ? organization.maxPayoutAmount + ' XOF' : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ organization.payoutValidationDelay ? organization.payoutValidationDelay + ' min' : '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="organization.status==='ACTIVE'">{{ $t('organizations.active') }}</span>
                <span class="badge text-outline-danger" v-if="organization.status==='INACTIVE'">{{ $t('organizations.inactive') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="`/companyusers/${organization.code}`"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        v-if="current_permissions('list_users')"
                      >
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        {{ $t('organizations.users') }}
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`/account/${organization.code}`"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        v-if="current_permissions('show_account')"
                      >
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        {{ $t('organizations.accounts') }}
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`/fees/${organization.code}`"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        v-if="current_permissions('show_fee')"
                      >
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        {{ $t('organizations.fees') }}
                      </router-link>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="changeStatus(organization.status,organization.code)"
                        v-if="current_permissions('status_organization')"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span v-if="organization.status==='ACTIVE'">{{ $t('organizations.deactivate') }}</span>
                        <span v-if="organization.status==='INACTIVE'">{{ $t('organizations.activate') }}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#companyModal"
                        @click="showOrganization(organization.code)"
                        v-if="current_permissions('show_organization')"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        {{ $t('organizations.edit') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="paginatedOrganizations.length === 0">
              <td colspan="9" class="text-center py-20">
                {{ $t('organizations.noResult') || 'Aucun résultat' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>itemsPerPage" class="mb-0 text-paragraph">
          {{ $t('organizations.showing') }} <span class="fw-bold">{{ Math.min(page*itemsPerPage, filteredTotal) }}</span> {{ $t('organizations.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('organizations.results') }}
        </p>
        <p v-if="filteredTotal<=itemsPerPage" class="mb-0 text-paragraph">
          {{ $t('organizations.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('organizations.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('organizations.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="changePage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="changePage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="changePage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Organization -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('organizations.createOrg') : $t('organizations.editTitle') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.companyName') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.companyNamePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.phone') }}</label>
                  <div>
                    <input v-model="formValues.contact" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.phonePlaceholder')" @blur="validate_phone_number($event.target.value,$event.target)" @keyup="validate_phone_number($event.target.value,$event.target)" @change="validate('contact')" :class="{ 'is-invalid': errorsBis['contact'] }" />
                    <span class="invalid-feedback">{{ errorsBis['contact']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.email') }}</label>
                  <div>
                    <input v-model="formValues.email" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" placeholder="info@imoney.africa" @blur="validate('email')" @keyup="validate('email')" :class="{ 'is-invalid': errorsBis['email'] }" />
                    <span class="invalid-feedback">{{ errorsBis['email']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.cryptoAccount') }}</label>
                  <div>
                    <input v-model="formValues.cryptoAccount" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.cryptoPlaceholder')" @blur="validate('cryptoAccount')" @keyup="validate('cryptoAccount')" :class="{ 'is-invalid': errorsBis['cryptoAccount'] }" />
                    <span class="invalid-feedback">{{ errorsBis['cryptoAccount']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.bank') }}</label>
                  <div>
                    <input v-model="formValues.bankDomiciliation" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.bankPlaceholder')" @blur="validate('bankDomiciliation')" @keyup="validate('bankDomiciliation')" @change="validate('bankDomiciliation')" :class="{ 'is-invalid': errorsBis['bankDomiciliation'] }" />
                    <span class="invalid-feedback">{{ errorsBis['bankDomiciliation']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.rib') }}</label>
                  <div>
                    <input v-model="formValues.rib" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.ribPlaceholder')" @blur="validate('rib')" @keyup="validate('rib')" :class="{ 'is-invalid': errorsBis['rib'] }" />
                    <span class="invalid-feedback">{{ errorsBis['rib']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.requiresValidation') }}</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleValidationChange" required>
                    <option value="N" :selected="selectedValidation=='N'">{{ $t('organizations.no') }}</option>
                    <option value="O" :selected="selectedValidation=='O'">{{ $t('organizations.yes') }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.type') }}</label>
                  <select name="type" id="type" class="form-select fs-md-15 text-black shadow-none" @change="handleTypeChange" required>
                    <option value="LEGAL" :selected="selectedType=='LEGAL'">{{ $t('organizations.legal') }}</option>
                    <option value="PERSON" :selected="selectedType=='PERSON'">{{ $t('organizations.person') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.maxPayoutAmount') }}</label>
                  <div>
                    <input v-model="formValues.maxPayoutAmount" type="number" step="0.01" min="0" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('organizations.maxPayoutAmountPlaceholder')" @blur="validate('maxPayoutAmount')" @keyup="validate('maxPayoutAmount')" :class="{ 'is-invalid': errorsBis['maxPayoutAmount'] }" />
                    <span class="invalid-feedback">{{ errorsBis['maxPayoutAmount']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.payoutValidationDelay') }}</label>
                  <div>
                    <input v-model="formValues.payoutValidationDelay" type="number" min="0" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('organizations.payoutValidationDelayPlaceholder')" @blur="validate('payoutValidationDelay')" @keyup="validate('payoutValidationDelay')" :class="{ 'is-invalid': errorsBis['payoutValidationDelay'] }" />
                    <span class="invalid-feedback">{{ errorsBis['payoutValidationDelay']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('organizations.description') }}</label>
                  <div>
                    <textarea v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('organizations.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }">
                    </textarea>
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_organization')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('organizations.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import conf from '../../../../env.json';
import { useI18n } from "vue-i18n";
import router from '../../../router/index'
import { current_permissions } from '../../../utils/permission';
import { useRouter } from 'vue-router';
import * as yup from 'yup';
import { validate_phone_number, showToast, checkSessionValidate } from "../../../utils/function";
import { Organization } from "@/utils/Model";

const backApi = inject('back');

const itemsPerPage = 10;
const page = ref(1);

const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const selectedValidation = ref('N');
const selected = ref(false);
const selectedType = ref('LEGAL');
const { t } = useI18n();
let edit = 0;
let itemCode = '';
const errorId = ref('');
let token: string | null = localStorage.getItem('login_token');

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}

const searchQuery = ref('');

const allOrganizations = ref(new Array<Organization>());

const filteredOrganizations = computed(() => {
  if (!searchQuery.value.trim()) return allOrganizations.value;
  const q = searchQuery.value.toLowerCase();
  return allOrganizations.value.filter((o: any) => {
    return [
      o.name,
      o.bankDomiciliation,
      o.rib,
      o.cryptoAccount,
      o.email,
      o.maxPayoutAmount ? String(o.maxPayoutAmount) : '',
      o.payoutValidationDelay ? String(o.payoutValidationDelay) : '',
      o.status === 'ACTIVE' ? t('organizations.active') : o.status === 'INACTIVE' ? t('organizations.inactive') : ''
    ].some(field => field?.toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredOrganizations.value.length);

const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / itemsPerPage)));

const paginatedOrganizations = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return filteredOrganizations.value.slice(start, start + itemsPerPage);
});

watch(searchQuery, () => {
  page.value = 1;
});

watch(numPages, (newNumPages) => {
  if (page.value > newNumPages) {
    page.value = newNumPages;
  }
});

const changePage = (numPage: number) => {
  if (numPage < 1 || numPage > numPages.value) return;
  page.value = numPage;
};

const errors = ref('');
const success = ref('');
const errorsBis = {
  'name': '',
  'description': '',
  'email': '',
  'contact': '',
  'bankDomiciliation': '',
  'rib': '',
  'cryptoAccount': '',
  'maxPayoutAmount': '',
  'payoutValidationDelay': ''
};
const pageLoad = ref(false);

const formValues = reactive({
  email: "",
  description: "",
  name: "",
  contact: "",
  bankDomiciliation: "",
  rib: "",
  cryptoAccount: "",
  maxPayoutAmount: 0,
  payoutValidationDelay: 0
});

const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const schema = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('La raison sociale est requise'),
  description: yup.string().required('La description est requise'),
  contact: yup.string().required('Le numéro de téléphone est requis').matches(phoneRegExp, "Veuillez saisir un numéro de telephone valide").test('len', "Le numero de téléphone doit faire exactement 10 chiffres", val => val && val.length === 10),
  bankDomiciliation: yup.string().required('Le nom de la banque est requis'),
  rib: yup.string().required('Le RIB est requis'),
  cryptoAccount: yup.string(),
  maxPayoutAmount: yup.number().min(0, 'Le montant doit être positif').nullable(),
  payoutValidationDelay: yup.number().min(0, 'Le délai doit être positif').nullable()
});

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

const showScreen = (code) => {
  itemCode = code;
}

const initField = () => {
  formValues.name = '';
  formValues.contact = '';
  formValues.email = '';
  formValues.description = '';
  formValues.bankDomiciliation = '';
  formValues.rib = '';
  formValues.cryptoAccount = '';
  formValues.maxPayoutAmount = 0;
  formValues.payoutValidationDelay = 0;
  selectedValidation.value = 'N';
  selected.value = false;
  selectedType.value = 'LEGAL';
  itemCode = '';
  edit = 0;
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeOrganization()
  } else {
    updateOrganization()
  }
}

const showOrganization = (code) => {
  axios.get(backApi + '/secure/organizations/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name || '';
      formValues.description = response.data.description || '';
      formValues.contact = response.data.contact || '';
      formValues.email = response.data.email || '';
      formValues.bankDomiciliation = response.data.bankDomiciliation || '';
      formValues.rib = response.data.rib || '';
      formValues.cryptoAccount = response.data.cryptoAccount || '';
      formValues.maxPayoutAmount = response.data.maxPayoutAmount || 0;
      formValues.payoutValidationDelay = response.data.payoutValidationDelay || 0;

      selectedValidation.value = (response.data.validatePayoutBeforProcess) ? 'O' : 'N';
      selected.value = response.data.validatePayoutBeforProcess;
      selectedType.value = response.data.type || 'LEGAL';
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const fetchOrganizationsPage = (pageNum: number) => {
  return axios.get(backApi + '/secure/organizations/' + pageNum, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const loadAllOrganizations = () => {
  fetchOrganizationsPage(1)
    .then((response) => {
      const firstPageData = response.data.organizations || [];
      const totalPages = parseInt(response.data.pagination.numPages) || 1;

      if (totalPages <= 1) {
        allOrganizations.value = firstPageData;
        return;
      }

      const requests = [];
      for (let p = 2; p <= totalPages; p++) {
        requests.push(fetchOrganizationsPage(p));
      }

      Promise.all(requests)
        .then((responses) => {
          let combined = [...firstPageData];
          responses.forEach((res) => {
            combined = combined.concat(res.data.organizations || []);
          });
          allOrganizations.value = combined;
        })
        .catch((error) => {
          console.log(error);
          allOrganizations.value = firstPageData;
        });
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/organizations/${code}/status`, {
    organization: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    if (response.status === 200) {
      showToast("Organisation activée avec succès", "green");
      router.go();
    }
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const changevalidatePayout = (status, code) => {
  axios.put(`${backApi}/secure/payout-validation-process`, {
    validatePayoutBeforProcess: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    if (response.status === 200) {
      showToast("Organisation activée avec succès", "green");
      router.go();
    }
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeOrganization = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/organizations/new`, {
      name: formValues.name,
      email: formValues.email,
      contact: formValues.contact,
      description: formValues.description,
      bankDomiciliation: formValues.bankDomiciliation,
      rib: formValues.rib,
      cryptoAccount: formValues.cryptoAccount,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      type: selectedType.value,
      maxPayoutAmount: formValues.maxPayoutAmount || 0,
      payoutValidationDelay: formValues.payoutValidationDelay || 0
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

const updateOrganization = () => {
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/organizations/${itemCode}/edit`, {
      code: itemCode,
      name: formValues.name,
      email: formValues.email,
      contact: formValues.contact,
      description: formValues.description,
      bankDomiciliation: formValues.bankDomiciliation,
      rib: formValues.rib,
      cryptoAccount: formValues.cryptoAccount,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      type: selectedType.value,
      maxPayoutAmount: formValues.maxPayoutAmount || 0,
      payoutValidationDelay: formValues.payoutValidationDelay || 0
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errors.value = error.response.data.message || 'Une erreur est survenue';
          showToast(errors.value, "red");
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;

    });
  errors.value = ''
}

onMounted(() => {
  checkSessionValidate(1)
  loadAllOrganizations();
  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>